import { FC } from "react";
import SalifyFormTextFieldWrapper, {
  SalifyFormTextFieldWrapperProps,
} from "./common/text-field-wrapper";

const SalifyFormTextFieldMultiline: FC<SalifyFormTextFieldWrapperProps> = ({
  field,
  textFieldProps,
}) => {
  return (
    <SalifyFormTextFieldWrapper
      field={field}
      textFieldProps={{ ...textFieldProps, multiline: true }}
    />
  );
};

SalifyFormTextFieldMultiline.displayName = "SalifyFormTextFieldMultiline";

export default SalifyFormTextFieldMultiline;
